import React from 'react';
import Link from "gatsby-link";
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Header from '../components/Header';
import NavMenu from '../components/navmenu';
import Footer from '../components/Footer';

import '../../sass/style.scss';

const TemplateWrapper = ({ children }) => (
  <div class="site-container">
    <Helmet>
      <title>FirstStep - The investment account of the future</title>
      <meta name="keywords" content="investments, investing, etf, exchange traded fund, loose change, spare change, diversified portfolio, mobile app, no minimum investment, australia fintech, roundups, save money, saving"/>
      <meta name="description" content="Download FirstStep, an investment account that is smarter and friendlier than your bank. Open an account in minutes, invest your spare change into global ETFs, manage your money on the go, create multiple accounts to reach saving goals for yourself or together with family and friends."/>
      <meta name="author" content="FirstStep Investments"/>
    </Helmet>
    <NavMenu />
    <Header />
    <main class="site-content">
      {children()}
    </main>
    <Footer />
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js